var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-content"},[_c('OrganizationForm',{attrs:{"isModalForm":true,"btn-text":'Продлить подписку',"call-back-func":_vm.componentProps.createSubscription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }